import _ from "lodash"
import { common, responsiveCSSStyle } from "./styles"

function applyYAxisPlugin(yAxis) {
  _.set(yAxis, "labels.style", responsiveCSSStyle())
  // _.set(yAxis, "labels.format", "{value}")
  _.set(yAxis, "gridLineColor", common.lightGrey)
  _.set(yAxis, "gridLineWidth", 1)
}

/**
 * Custom yAxis
 * @param chartOpts
 * @returns {*}
 */
export default function yAxisPlugin(chartOpts) {
  if (!chartOpts.yAxis) {
    return chartOpts
  }

  if (_.isArray(chartOpts.yAxis)) {
    chartOpts.yAxis.forEach(applyYAxisPlugin)
    return chartOpts
  }
  // simple axis apply
  applyYAxisPlugin(chartOpts.yAxis)
  return chartOpts
}
